/**
 * General highcharts lang object
 * @author Pablo Vidal
 */
global.HighchartsLocale = {};


